export const FILTER_SAVED = 'group/filter_saved';
